<style scoped lang="scss">
.show-profile-body {
  display: flex;
  flex-direction: row;
  img {
    height: 80px !important;
    width: 80px !important;
    background: #fff;
    border-radius: 100%;
  }
  .user-info-content {
    width: 100%;
    .action {
      display: flex;
      width: 100%;
      justify-content: flex-end;
    }
  }
}
.side-menu {
  display: block;
  margin: 0 auto;
  max-width: 300px;
  padding: 10px;
}
#main-content {
  width: 100%;
}
@media (min-width: 768px) and (max-width: 1024px) {
  #main-content {
    width: 65%;
  }
  .desktop-header {
    width: 100%;
    margin: 0 auto;
  }
}

@media (min-width: 1025px) {
  #main-content {
    width: 40%;
  }
}

.side-navigation-container {
  height: calc(100vh - 84px);
  position: relative;
  top: 84px;
  width: 30%;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .side-navigation-container {
    display: none !important;
  }
}

@media (max-width: 1024px) {
  .side-navigation-container:empty {
    width: 18%;
  }
}
</style>
<style lang="scss">
@media (max-width: 767px) {
  .show-profile-modal {
    .ivu-modal {
      width: auto !important;
      margin: 0 20px !important;
    }
  }
}
.show-profile-modal {
  .ivu-modal {
    width: 400px;
    margin: 0 auto; 
  }
  .ivu-modal-footer {
    display: none;
  }
}
.doActionModal .ivu-modal-footer {
  padding: 0;
}
/* .doActionModal .ivu-modal-footer:after {
  content: ' ';
  width: 20px;
  height: 20px;
  position:absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 15px solid #fff;
  bottom: -20px;
} */
.doActionModal .ivu-modal-body .app-logo > img {
  margin-top: -10px;
}

.doActionModal .ivu-modal-header {
  padding: 0;
  border-bottom: none;
  display: none;
}
.doActionModal .ivu-modal {
  bottom: 75px;
  top: auto;
  position: absolute;
  left: 125px;
  right: 0;
  width: 280px !important;
  margin: 0 auto;
}

.app-logo > img {
  /* position: absolute; */
  /* top: 0; */
  /* left: 8px; */
  width: 55px !important;
  height: auto !important;
}
</style>


<template>
  <div
    class="main-template"
    :class="('type' in mobileView && mobileView.type) ? 'mobile-web-view':''"
  >
    <div v-if="showOnboardingModal">
      <OnBoardingModal></OnBoardingModal>
    </div>
    <div>
      <UserFollowModal></UserFollowModal>
    </div>
    <div>
      <VerifyModal></VerifyModal>
    </div>
    <div>
      <InviteChoicesModal></InviteChoicesModal>
    </div>
    <div>
      <CareTeamJoinConsentModal
        :journalCareplanId="careteamJoinCode"
        :prescriberId="prescriberId"
        :invitationId="invitationId"
        :is-show="careteamJoinModal"
        :isRequest="false"
        @close="careteamJoinModal = false"
      />
      <GroupInviteModal
        @close="showGroupInvite = false"
        :invitationId="invitationId"
        :show="showGroupInvite"
      ></GroupInviteModal>
    </div>
    <div>
      <PointsBreakdownModal />
    </div>

    <audio
      style="position:fixed;z-index:-10;opacity: 0;"
      :src="soundWave"
      autostart="false"
      width="0"
      height="0"
      id="AlertTone"
      enablejavascript="true"
    />
    <!-- <Row class="header-template" type="flex" justify="center"> -->
    <!-- <Col :xs="0" :sm="0" :md="6" :lg="7">
        <Row>
          <Col span="24">
            <Affix>
              <div class="side-menu">
                <MenuComponent></MenuComponent>
              </div>
            </Affix>
          </Col>
        </Row>
    </Col>-->
    <DrawerLayout
      ref="drawerLayout"
      :reverse="true"
      :class="'hide-drawer-wrapper'"
      @mask-click="dismissDrawer"
      @slide-end="endSlide"
      :z-index="9999"
    >
      <div class="drawer-content" slot="drawer">
        <menu-component></menu-component>
      </div>
    </DrawerLayout>
    <Row class="header-template" type="flex" justify="center">
      <i-col :xs="24" :sm="24" :md="24" :lg="24">
        <AppHeader></AppHeader>
        <div style="display: flex;">
          <div class="side-navigation-container">
            <SideNavigationComponent v-if="showDesktopSideNavigation" />
          </div>
          <div id="main-content" class="stl-main-content">
            <transition name="fade" mode="out-in">
              <router-view
                :class="('type' in mobileView && mobileView.type) ? 'mobile-web-view m-container':''"
              ></router-view>
            </transition>
          </div>
          <div>
            <AppToolBarComponent></AppToolBarComponent>
          </div>
        </div>
      </i-col>
    </Row>

    <!-- </Row> -->
    <PostUpdateModalComponent v-on:emitProceed="onProceed"></PostUpdateModalComponent>
    <PostUpdateComponent></PostUpdateComponent>
    <PostDocumentComponent />

    <Modal
      class="doActionModal"
      v-model="$store.state.base.showDoAction"
      :mask-closable="true"
      :closable="false"
    >
      <!-- <p slot="header">
          <div @click="closeDoAction">
            <Avatar class="app-logo" style="height:50px;margin:0 auto;background:white;padding:5px; width:100%" :src="appLogo"></Avatar>
          </div>
      </p>-->
      <div @click="closeDoAction()">
        <do-action-menu></do-action-menu>
      </div>
      <div slot="footer"></div>
    </Modal>

    <!-- show profile modal -->
     <Modal
      v-model="showProfileModal"
      :mask-closable="true"
      :closable="false"
      class="show-profile-modal"
    >
      <div slot="header">
        <p align="start">
          View user Profile
         </p>
        <img
          @click="closeProfileModal"
          style="height:25px; width:25px;position:absolute;top:0;right:0;margin:10px 10px 0 0;"
          src="@/assets/close.png"
          class="pointer"
        />
      </div>
      <div class="show-profile-body">
        <div style="width: 35%">
          <img :draggable="false" :src="profileModalInfo.avatar"/>
        </div>
        <div class="user-info-content">
          <p class="truncate" style="width: 200px;">
            <b>
              {{profileModalInfo.display_name}}
            </b>
          </p>
          <p style="color: red; height: 34px;">
            <small v-show="profileModalInfo.is_public == 0">
                User profile is not Public
            </small>
          </p>
          <div class="action">
            <Button @click="closeProfileModal">Cancel</Button>
            <Button 
              v-if="profileModalInfo.is_public == 1"
              style="margin-left: 10px;"
              type="primary"
              @click="goToProfile()"
              >
              View
              </Button>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
// import DoActionMenu from '@/views/DoActionMenu';
import _ from "lodash";
import axios from "axios";
import * as API from "@/endpoints";

import DoActionMenu from "@/views/DoActionMenuB";
import MenuComponent from "@/views/MenuComponent";
import AppHeader from "@/components/AppHeaderComponent";
import AppToolBarComponent from "@/components/AppToolBarComponent";
import OnBoardingModal from "@/components/OnBoardingComponent";
import UserFollowModal from "@/components/ModalUserFollowListComponent";
import VueCookie from "vue-cookie";
import logo from "@/assets/logo.png";
import { DrawerLayout } from "vue-drawer-layout";
import VerifyModal from "@/components/VerifyModal";
import InviteChoicesModal from "@/components/InviteModal";
import GroupInviteModal from "@/components/GroupInviteModal";
import CareTeamJoinConsentModal from "@/components/CareTeamJoinConsentModal";
import PointsBreakdownModal from "@/components/PointsBreakdownModal";

import PostUpdateModalComponent from "@/components/PostUpdateModalComponent";
import PostUpdateComponent from "@/views/PostUpdateComponent";
import PostDocumentComponent from "@/components/PostDocumentComponent";

import SideNavigationComponent from "@/components/desktop/SideNavigationComponent";

import soundWave from "@/assets/to-the-point.mp3";

export default {
  name: "MainComponent",
  data() {
    return {
      mobileView: {},
      appLogo: logo,
      showGroupInvite: false,
      invitationId: "",
      prescriberId: "",
      careteamJoinModal: false,
      careteamJoinCode: "",
      soundWave
    };
  },
  watch: {
    careteamRequestCode: {
      immediate: true,
      handler(n) {
        if (n) {
          setTimeout(() => {
            axios.get(API.endpoints.prescribe + "/careplan/" + n).then(res => {
              this.invitationId = n;
              this.prescriberId = res.data.prescriber.id;
              this.careteamJoinModal = true;
              this.careteamJoinCode = n;
            });
          }, 2000);
        }
      }
    },
    groupInviteCode: {
      immediate: true,
      handler(n) {
        if (n)
          setTimeout(() => {
            BroadcastEvent.$emit("onGroupInvitation", {
              show: true,
              invitation_id: n
            });
          }, 2000);
      }
    }
  },
  methods: {
    goToProfile() {
      this.$router.push("/profile/" + this.profileModalInfo.id);
      this.closeProfileModal();
    },
    closeProfileModal() {
      this.showProfileModal = false
      this.$store.commit("base/setShowProfileInfo", {})
    },
    onProceed: _.debounce(function(data) {
      if (data != "journal_public" && data != "journal_private") {
        let careplanId = data.id;
        this.$store.commit("menu/setPostSelectionModal", false);
        this.$router.push({
          query: {
            ...this.$route.query,
            post: careplanId,
            action: "post"
          }
        });

        this.$store.commit("publicModule/setShowPostItemModal", true);
      } else {
        if (data == "journal_public") {
          this.$store.commit("menu/setPostSelectionModal", false);
          this.$router.push({
            query: {
              ...this.$route.query,
              post: this.profileInfo.careplan_id,
              action: "post",
              is_public: true,
              tab: "timeline"
            }
          });

          this.$store.commit("publicModule/setShowPostItemModal", true);
        } else {
          this.$store.commit("menu/setPostSelectionModal", false);
          this.$router.push({
            query: {
              ...this.$route.query,
              post: this.profileInfo.private_careplan_id,
              action: "post",
              is_public: false,
              tab: "team"
            }
          });

          this.$store.commit("publicModule/setShowPostItemModal", true);
        }
      }
    }, 0),
    eventEmitter() {
      BroadcastEvent.$on("onActivityOptions", item => {
        console.log("activity id...", item);
        this.activityOptions = true;
      });
      BroadcastEvent.$on("onToggleBurger", () => {
        if (this.$refs.drawerLayout) {
          this.$refs.drawerLayout.toggle();
          let el = document.getElementsByClassName("drawer-layout");
          el[0].classList.remove("hide-drawer-wrapper");
        }
      });
      BroadcastEvent.$on("addNewShareActivity", v => {
        this.$store.commit("systemAlert/addShareItem", {
          act: v.data,
          this: this
        });
      });
      BroadcastEvent.$on("removeShareActivity", v => {
        this.$store.commit("systemAlert/removeShareItem", {
          act: v.data,
          this: this
        });
        if (
          this.shareableActivity.data &&
          this.shareableActivity.data.length < 1
        ) {
          this.onCallToActionClose();
        } else if (!this.shareableActivity.data) {
          this.onCallToActionClose();
        }
      });
    },
    dismissDrawer() {
      this.$refs.drawerLayout.toggle();
      let el = document.getElementsByClassName("drawer-layout");
      el[0].classList.add("hide-drawer-wrapper");
    },
    endSlide() {
      let el = document.getElementsByClassName("drawer-layout");
      if (this.$refs.drawerLayout && this.$refs.drawerLayout.visible)
        el[0].classList.remove("hide-drawer-wrapper");
      else el[0].classList.add("hide-drawer-wrapper");
    },
    closeDoAction() {
      this.$store.commit("base/showDoActionModal", false);
    },
    onCallToActionClose() {
      this.$vlf
        .createInstance({
          storeName: "systemAlert"
        })
        .then(v => {
          v.setItem("showAlert", false);
          this.$store.commit("systemAlert/setShowSystemAlert", false);
          v.removeItem("remindLater");
          clearInterval(checkReminder);
        });
    }
  },
  computed: {
    showProfileModal: {
      get() {
        return this.$store.state.base.showProfile.show
      },
      set(v) {
        this.$store.commit("base/setShowProfileModal", v)
      }
    },
    profileModalInfo() {
      return this.$store.state.base.showProfile.user
    },
    careteamRequestCode() {
      return this.$route.query.care_team_request_code;
    },
    groupInviteCode() {
      return this.$route.query.group_invite_code;
    },
    showDesktopSideNavigation() {
      return this.$route.name !== "OnBoarding-Brand";
    },
    bullhorn: {
      get() {
        return require("@/assets/bullhorn.png");
      }
    },
    showOnboardingModal: {
      get() {
        return this.$store.state.user.showOnboardingModal && navigator.onLine;
      }
    },
    pageTitle: {
      get() {
        return "title" in this.$route.meta && this.$route.meta.title
          ? this.$route.meta.title
          : "Welcome";
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    isMobile: {
      get() {
        return this.$store.state.isMobile;
      }
    },
    shareableActivity: {
      get() {
        return this.$store.state.systemAlert.shareableActivity;
      }
    }
  },
  created() {
    this.eventEmitter();

    if (VueCookie.get(Cons[0].PATHS.NAME + "MOBILE")) {
      let data = VueCookie.get(Cons[0].PATHS.NAME + "MOBILE");
      this.mobileView = JSON.parse(data);
      this.$store.commit("setMobileViewData", JSON.parse(data), { root: 1 });
    }
  },
  mounted() {
    this.$store.dispatch("user/getUserFeed");
    this.$store.dispatch("getActionMenu", null, { root: 1 });
    // this.$store.dispatch('user/getDocumentCategory');
    this.$store.commit("user/setLoadingReporting", false);
    // this.$store.dispatch('user/reportCategory').then(
    //   res=>{
    //     this.reportSelected = res;
    //   }
    // );
    // this.$store.dispatch('user/category');

    BroadcastEvent.$on("onGroupInvitation", payload => {
      this.showGroupInvite = payload.show;
      this.invitationId = payload.invitation_id;
    });
  },
  beforeDestroy() {
    BroadcastEvent.$off("onGroupInvitation");
  },
  components: {
    DrawerLayout,
    OnBoardingModal,
    AppHeader,
    AppToolBarComponent,
    DoActionMenu,
    MenuComponent,
    UserFollowModal,
    PostUpdateModalComponent,
    PostUpdateComponent,
    VerifyModal,
    InviteChoicesModal,
    PostDocumentComponent,
    SideNavigationComponent,
    GroupInviteModal,
    CareTeamJoinConsentModal,
    PointsBreakdownModal
  }
};
</script>

